import { render, staticRenderFns } from "./Investigations.vue?vue&type=template&id=611b7971&scoped=true&"
import script from "./Investigations.vue?vue&type=script&lang=js&"
export * from "./Investigations.vue?vue&type=script&lang=js&"
import style0 from "./Investigations.vue?vue&type=style&index=0&id=611b7971&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "611b7971",
  null
  
)

export default component.exports